import React, { useEffect, useRef } from 'react'
import { create } from 'pinch-zoom-pan'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

interface PinchZoomPanProps {
    min?: number
    max?: number
    captureWheel?: boolean
    className?: string
    style?: React.CSSProperties
    children: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    transform: 'translateZ(0)',
    overflow: 'hidden',
    flex: 1,
  },
  point: {
    position: 'absolute',
    width: 0,
    height: 0,
    transform: 'translate(0, 0) scale(1)',
    transformOrigin: 'center',
    willChange: 'transform',
  },
  canvas: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
}))

export interface IPinchZoomPanProps {
    min: number
    max: number
    captureWheel: boolean
}

const PinchZoomPan: React.FC<PinchZoomPanProps> = ({ min, max, captureWheel, children }) => {
  const classes = useStyles()
  const root = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = root.current
    if (!element) return
    return create({ element, minZoom: min, maxZoom: max, captureWheel })
  }, [min, max, captureWheel])

  return (
    <div ref={root} className={classes.root}>
      <div className={classes.point}>
        <div className={classes.canvas}>
          {children}
        </div>
      </div>
    </div>
  )
}
export default PinchZoomPan
